// extracted by mini-css-extract-plugin
module.exports = {"circle":"BackArrow_circle__bgAH_","planck":"BackArrow_planck__1LwDj","back":"BackArrow_back__KJQsO","BackArrow":"BackArrow_BackArrow__NAjBU"};